# TODO: brittany 10/4 - Possibly stale - all related to evaluations/reviews

$(->
  $('#evaluation_frequency').change(->
    sel = $('#evaluation_due_at')
    sel.html('')
    if sel.data('due-at-collections') != undefined
      opts = sel.data('due-at-collections')[$(this).val()]
      default_val = null
      for opt in opts
        sel.append('<option value="' + opt[1] + '">' + opt[0] + '</option>')
        if default_val == null && new Date(opt[1]) > new Date()
          default_val = opt[1]

      sel.val(sel.data('orig-value'))
      if sel.val() == ''
        sel.val(default_val)
  ).trigger('change')

  $('a.show-all-goal-trackers').click ->
    $('.older.row').show()
    $(this).remove()
    false

  $(document).on 'change', '#checkin-questions input.selected', ->
    if $(this).val() == "1"
      $(this).closest('fieldset.inputs').find('.frequency_wrapper input').prop('disabled', false)
    else
      $(this).closest('fieldset.inputs').find('.frequency_wrapper input').prop('disabled', true)

  $('#checkin-questions input.selected').change()

  $(document).on 'click', '.question_frequency a.select-all,.frequency_wrapper a.select-all', ->
    cur_val = ($(this).data('checked') == null || $(this).data('checked') == true)
    $(this).closest('fieldset').find('input').prop('checked', !cur_val)
    $(this).data('checked', !cur_val)
    false

  $(document).on 'change', '.weight_wrapper input', ->
    the_input = $(this)
    if the_input.val().length > 0
      the_span = the_input.parent().find('span.calc')
      the_span.find('span').each ->
        $(this).html(sprintf("%.1f", parseFloat(the_input.val()) * parseFloat($(this).data('calc'))))
      the_input.parent().find('span.calc').show()
    else
      the_input.parent().find('span.calc').hide()

  $('.weight_wrapper input').change()

  $('.employee_frequency').change ->
    if $(this).prop('checked') == true
      new_freq = 0
    else
      new_freq = 1
    $(this).closest('.employee_goals').find('.weight_wrapper').each ->
      the_wrapper = $(this)
      freq_data = eval(the_wrapper.data('frequency'))
      $.each freq_data, (i, val)->
        if val.value == new_freq
          the_wrapper.find('label').html(val.label)
    $(this).closest('.employee_goals').find('.weight_wrapper input').change()
  $('.employee_frequency').change()

  $(document).on 'change', '.type_wrapper select.question_type', ->
    the_input = $(this)
    if the_input.data('calc') != null
      if $.inArray(parseInt(the_input.val(),10), the_input.data('calc')) < 0
        the_input.closest('fieldset.inputs').find('.weight_wrapper').hide()
      else
        the_input.closest('fieldset.inputs').find('.weight_wrapper').show()

  $('.type_wrapper select.question_type').change()

  if $('#goal_set_quick_update').length > 0
    $('#goal_set_frequency').change ->
      $('#goal_set_quick_update').val('1')
      $(this).closest('form').submit()

  # brittany 10/4 - this looks generic but I believe in reality is tied solely to evaluations
  # see scoring_sets_helper > evaluation_employee_invite_untaken
  $('a.send_invite').click ->
    if $(this).data('link')?
      the_popup = window.get_modal_markup()
      the_popup.html(window.get_modal_content($(this).data('type') + ' Reminder', '<p>An email message should have been loaded, if you do not see this message, or wish to access the incomplete ' + $(this).data('type') + ' directly please <a href="' + $(this).data('link') + '" target="_blank">click here</a>.', ''))
      the_popup.modal()
    true

  $('select.team-selector').change ->
    window.location.assign('/manage/reviews?team=' + $(this).val());

  $('#reviews_include_goals').change ->
    if $(this).prop('checked')
      $('.employee-section .goal_set input').prop('disabled', false)
      $(this).closest('p.indent').find('select').prop('disabled', false)
    else
      $('.employee-section .goal_set input').prop('disabled', true).prop('checked', false)
      $(this).closest('p.indent').find('select').prop('disabled', true)

  $('#reviews_include_evaluations').change ->
    if $(this).prop('checked')
      $('.employee-section .evaluation input').prop('disabled', false)
      $(this).closest('p.indent').find('select').prop('disabled', false)
    else
      $('.employee-section .evaluation input').prop('disabled', true).prop('checked', false)
      $(this).closest('p.indent').find('select').prop('disabled', true)

  $('a.evals_update_team').click ->
    $('#evals_update_team_form').data('app', $(this).data('app'))
    $.ajax
      url: "/manage/employees/" + $(this).data('app') + ".json"
      success: (app)->
        $('#evals_update_team_form').modal()
        $('#evals_update_team_form #app_has_goals').prop('checked', app.has_goals)
        $('#evals_update_team_form #app_has_evals').prop('checked', app.has_evals)
        $('#evals_update_team_form #app_employment_status').val(app.employment_status)
    false

  $('#evals_update_team_form button.btn-primary').click ->
    $('#evals_update_team_form').modal('hide')
    $.ajax
      url: "/manage/employees/" + $('#evals_update_team_form').data('app') + ".json"
      type: 'PATCH'
      data: $('#evals_update_team_form fieldset').serialize()
      success: (app)->
        unless app.has_goals
          $('#emp_goals_' + app.id).remove()
        unless app.has_evals
          $('#emp_evals_' + app.id).remove()
    false

)
